import { ReactNode } from "react";

/** The searched text inside a sentence, set apart by weight since quotes would clash with quoted queries. */
export const QueryText = ({ children }: { children: ReactNode }) => (
  <span className="font-semibold text-foreground">{children}</span>
);
